// import {
//   FacebookShareButton,
//   LinkedinShareButton,
//   TelegramIcon,
//   TelegramShareButton,
// } from 'next-share';
import Image from 'next/image';
import Link from 'next/link';

export const ShareButtons = () => {
  const shareUrl =
    typeof window !== 'undefined'
      ? window.location.href
      : 'https://www.microkhim.com.ua/team';
  const fbShare = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
  const linkedInShare = `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`;
  const telegramShare = `https://t.me/share/url?url=${shareUrl}&text=Поділитися`;

  return (
    <ul className="team-vacancy__share-list">
      <li className="team-vacancy__share-item">
        <Link
          href={fbShare}
          target="_blank"
          rel="noopener noreferrer"
          prefetch={false}
        >
          <Image
            src={'/icons/team/facebook.svg'}
            alt={'Facebook'}
            width={32}
            height={32}
            className="h-full w-full"
          />
        </Link>
      </li>
      <li className="team-vacancy__share-item">
        <Link
          href={telegramShare}
          target="_blank"
          rel="noopener noreferrer"
          prefetch={false}
        >
          <Image
            src={'/icons/team/telegram.svg'}
            alt={'Telegram'}
            width={32}
            height={32}
            className="h-full w-full"
          />
        </Link>
      </li>
      <li className="team-vacancy__share-item">
        <Link
          href={linkedInShare}
          target="_blank"
          rel="noopener noreferrer"
          prefetch={false}
        >
          <Image
            src={'/icons/team/linkedin.svg'}
            alt={'Linkedin'}
            width={32}
            height={32}
            className="h-full w-full"
          />
        </Link>
      </li>
    </ul>
  );
};
